const Environments = ['local', 'dev', 'prod'] as const;
type Environment = (typeof Environments)[number];

interface Context {
  env: Environment;
}

const contexts: Record<Environment, Context> = {
  local: {
    env: 'local',
  },
  dev: {
    env: 'dev',
  },
  prod: {
    env: 'prod',
  },
};

function inferEnvFromUrl(): Environment {
  const url = new URL(window.location.href);
  const host = url.host;

  switch (host) {
    case 'localhost:3000':
      return 'local';
    case 'localhost:3001':
      return 'local';
    case 'dev.canna42.com':
      return 'dev';
    case 'canna42.com':
      return 'prod';
    default:
      throw new Error(`Unknown environment for host: ${host}`);
  }
}

function getContext(): Context {
  const env = inferEnvFromUrl();
  return contexts[env];
}

export const context = getContext();
